
// import { gsap } from 'gsap';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el   : false,
        	main  : null,
        };

        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'captions_mobile_control';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

        this.$a             =   this.$el;
        this.$a.data( 'open', false );

		this.init( true );
    }

    init( b ){

        if ( $( 'html' ).hasClass( 'no-touch' ) ){
            return;
        }

        //console.log( 'init :: ' + this.namespace );

    	this.addEvents( b );
	}

    addEvents( b ){
        if ( b ){
            this.$a.on( 'click', (e) => this.toggleCaptions(e) );
        }
        else{
            this.$a.off( 'click', (e) => this.toggleCaptions(e) );
        }
    }

    toggleCaptions(e){
        e.stopImmediatePropagation();

        let open = this.$a.data( 'open' );

        if ( open ){

            this.$el.removeClass( 'open' );

        }
        else{

            this.$el.addClass( 'open' );
        }

        this.$a.data( 'open', !open );
    }

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
        this.init( false );
    }

}